<template>
<a-modal
  :title="title"
  :visible="visible"
  :footer="null"
  :width="800"
  :closable="false"
  :maskClosable="false"
  :keyboard="false"
  wrapClassName="collaboration-modal"
  @change="$emit('change', $event)"
  :afterClose="handleReset"
  destroy-on-close
>
  <svg-icon class-name="close" icon-class="close" @click.native="onCancel"></svg-icon>
  <div class="collaboration-container" ref="collaboration">
    <div class="item">
      <div class="label required">{{$t('home.Theme')}}</div>
      <div class="wrapper">
        <a-input v-model.trim="form.theme" @change="themeChange"></a-input>
      </div>
    </div>
    <div class="item">
      <div class="label required">{{$t('home.StartingTime')}}</div>
      <div class="wrapper date-picker-container">
        <a-date-picker
          class="start"
          :show-time="showTime"
          :show-today="false"
          format="YYYY-MM-DD HH:mm"
          :disabled-date="disabledDate"
          :disabled-time="disabledTime"
          :default-value="nowStep()"
          @openChange="handleStartOpenChange"
          v-model="form.beginTime"
          dropdownClassName="date-picker-simple"
        >
          <svg-icon slot="suffixIcon" icon-class="date-picker-default" />
        </a-date-picker>
        <div class="end-label required">{{$t('home.EndTime')}}</div>
        <a-date-picker
          class="end"
          :show-time="showTime"
          :show-today="false"
          format="YYYY-MM-DD HH:mm"
          :disabled-date="disabledDate"
          :disabled-time="disabledTime"
          :default-value="nowStep().add(15, 'minutes')"
          @openChange="handleEndOpenChange"
          :open="endOpen"
          v-model="form.endTime"
          dropdownClassName="date-picker-simple"
        >
          <svg-icon slot="suffixIcon" icon-class="date-picker-default" />
        </a-date-picker>
      </div>
    </div>
    <div class="item">
      <div class="label required">{{$t('home.Type')}}</div>
      <div class="wrapper wrapper-pointer" @click="tagModalVisible=true">
        <div class="types">
          <div class="noTypes" v-if="!form.tagList.length">{{$t('home.ClickAddType')}}</div>
          <div class="hasTypes" v-else>
            <div v-for="item in form.tagList" :key="item.id">{{item.name}}</div>
          </div>
          <svg-icon
            class-name="arrow-right"
            :icon-class="iconType"
          />
        </div>
      </div>
    </div>
    <div class="item">
      <div class="label">{{$t('home.Collaborator')}}</div>
      <div class="wrapper wrapper-pointer" @click="inviteMoreModalVisible=true">
        <div class="collaborator">
          <Collaborator
            :hostId="hostId"
            v-for="item in collaborator"
            :key="item.id"
            :collaborator="item"
          />
          <svg-icon
            class-name="arrow-right"
            :icon-class="iconColtor"
          />
        </div>
      </div>
    </div>
    <div class="item">
      <div class="label">{{$t('home.MoreHowManyCollaborators')}}</div>
      <div class="wrapper">
        <div class="morePeople">{{ $t('common.People').replace('XX', MAXROOMMEMBER)}}</div>
      </div>
    </div>
    <div class="item">
      <div class="label">{{$t('home.MemberJoinMute')}}</div>
      <div class="wrapper">
        <div class="collaborator">
          <div class="switch" v-if="+form.mute === 1" @click="_ => form.mute = 0">
            <svg-icon icon-class="switch-on" class-name="switch-on" />
            <span class="text">{{$t('common.TurnOn')}}</span>
          </div>
          <div class="switch" v-if="+form.mute === 0" @click="_ => form.mute = 1">
            <svg-icon icon-class="switch-off" class-name="switch-off"/>
            <span class="text">{{$t('common.Close')}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="item">
      <div class="label">{{$t('home.Attachment')}}</div>
      <div class="wrapper">
        <div class="collaborator attach-container">
          <div class="text-link upload-btn" @click="handleUploadAttachFile">
            <SvgIcon icon-class="upload" class-name="icon-upload" />
            <span class="upload-text">{{$t('home.UploadAttachment')}}</span>
          </div>
          <div class="attach-items">
            <div v-for="file,index in originFiles" :key="index" class="attach-item-container">
              <FileEntityIcon :filename="file.name" />
              <div class="attach-info">
                <div class="attach-info-name">
                  <span class="attach-info-name-segment" v-for="nameSeg,fnindex in getAttachName(file.name)" :key="fnindex" :style="{width: nameSeg.width}">{{nameSeg.text}}</span>
                </div>
                <div class="attach-info-desc">{{$t('home.From')}}：{{getAttachDesc(file)}}</div>
              </div>
              <div class="attach-action">
                <span class="remove-btn" @click="handleDeleteAttachFile(index)"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div :class="buttons">
    <BasicBtnGroup
      @primeClick="onOk"
      @defClick="onCancel"
      class="basic-btns"
      :disabled="disabled"
    >
      <span slot="defContent">{{cancelText}}</span>
      <span slot="primaryContent">{{okText}}</span>
    </BasicBtnGroup>
  </div>
  <TagModal v-model="tagModalVisible" @tagConfirm="tagConfirm" />
  <InviteMoreModal
    v-model="inviteMoreModalVisible"
    type="cooperation"
    :passSelectedMembers="passSelectedMembers"
    @inviteConfirm="inviteConfirm"
    :isHost="isHost"
  />
</a-modal>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import TagModal from '@/components/business/tag-modal/index'
import BasicBtnGroup from '@/components/behavior/basic-btn-group/index.vue'
import InviteMoreModal from '@/components/business/invite-more-modal'
import Collaborator from './Collaborator'
import SvgIcon from '@/components/behavior/svg-icon/index.vue'
import moment from 'moment'
import axios from 'axios'
import Global from '@/global'
import { clone, differenceWith } from 'ramda'
import { FileEntityIcon } from '@/components/behavior/file-entiry/index'
import { fileSelector } from '@/utils/file-selector'
import { uploadFile } from '@/utils/upload'
import { CONFERENCE_STATE } from '@/utils/constant'
import { format } from 'date-fns'
import { getTextWidth } from '@/utils/canvasUtils'

const chs10pt = getTextWidth('田'.repeat(10))
function nowStep() {
  const add15Minutes = moment().add(15, 'minutes')
  const stepMinute = add15Minutes.minute()
  switch (true) {
    case stepMinute >= 0 && stepMinute < 15:
      return add15Minutes.minute(0).second(0)
    case stepMinute >= 15 && stepMinute < 30:
      return add15Minutes.minute(15).second(0)
    case stepMinute >= 30 && stepMinute < 45:
      return add15Minutes.minute(30).second(0)
    case stepMinute >= 45 && stepMinute <= 59:
      return add15Minutes.minute(45).second(0)
  }
}
const initialColAppointData = (vm) => ({
  get title () { return vm.$t('home.AppointmentNow') },
  type: 'add',
  get cancelText () { return vm.$t('home.CancelAppointment') },
  get okText () { return vm.$t('home.Appointment') },
  preTheme: '',
  form: {
    theme: '',
    beginTime: nowStep(),
    endTime: nowStep().add(15, 'minutes'),
    tagList: [],
    collaboratorList: [],
    mute: 0
  },
  tagModalVisible: false,
  inviteMoreModalVisible: false,
  conferenceId: '',
  endOpen: false,
  originForm: {
    theme: '',
    beginTime: nowStep(),
    endTime: nowStep().add(15, 'minutes'),
    tagList: [],
    collaboratorList: []
  },
  iconType: 'arrow-right',
  iconColtor: 'arrow-right',
  showTime: {
    format: 'HH:mm',
    minuteStep: 15
  },
  hostId: '',
  originFiles: [],
  cloneOriginFiles: [],
  buttons: ['buttons'],
  muteTypeList: [
    { id: 1, label: '开启', value: 1 },
    { id: 2, label: '关闭', value: 0 }
  ]
})

export default {
  name: 'CollaborationAppointment',
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Collaborator,
    TagModal,
    BasicBtnGroup,
    InviteMoreModal,
    SvgIcon,
    FileEntityIcon,
  },
  data() {
    return initialColAppointData(this)
  },
  watch: {
    tagModalVisible(nv) {
      this.iconType = nv ? 'arrow-right-active' : 'arrow-right'
    },
    inviteMoreModalVisible(nv) {
      this.iconColtor = nv ? 'arrow-right-active' : 'arrow-right'
    },
    effectScrollData() {
      if (this.visible) {
        this.$nextTick(() => {
          const { scrollHeight, clientHeight } = this.$refs.collaboration
          this.buttons = scrollHeight > clientHeight
            ? ['buttons']
            : ['buttons', 'no-scroll']
        })
      }
    }
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters('coc', ['getCocDetialById', 'getOriginCocById']),
    ...mapGetters(['MAXROOMMEMBER']),
    // 是否出现滚动条主要是类型、协作方和附件会影响到
    effectScrollData() {
      const { form: { tagList, collaboratorList }, originFiles } = this
      return tagList.map(({ id }) => id)
        .concat(
          collaboratorList.map(({ userId }) => userId),
          originFiles.map(({ url }) => url)
        )
        .join('')
    },
    cocDetail() {
      const conferenceId = this.conferenceId
      if (conferenceId) {
        return this.getCocDetialById(conferenceId)
      }
      return null
    },
    collaborator() {
      const array = []
      Array.from(new Set(this.form.collaboratorList.map(el => el.corpId)))
        .forEach(el => {
          const obj = {}
          this.form.collaboratorList.forEach(ele => {
            if (ele.corpId === el) {
              obj.corpId = el
              obj.corpName = ele.corpName
              if (obj.nameList) {
                obj.nameList.push({
                  name: ele.nickName,
                  confirmStatus: ele.confirmStatus,
                  userId: ele.userId,
                })
              } else {
                obj.nameList = [{
                  name: ele.nickName,
                  confirmStatus: ele.confirmStatus,
                  userId: ele.userId,
                }]
              }
            }
          })
          array.push(obj)
        })
      return array
    },
    passSelectedMembers() {
      return this.form.collaboratorList.map(el => el.userId)
    },
    disabled() {
      return !(this.form.theme && this.form.beginTime && this.form.endTime && this.form.tagList.length)
    },
    isHost() {
      return this.hostId === this.userInfo.id
    }
  },
  methods: {
    ...mapMutations('tag', ['checkTag', 'clearChecked']),
    ...mapActions('tag', ['queryTagList']),
    ...mapMutations('coc', ['putCoc']),
    ...mapActions('coc', ['fetchCocDetail', 'deleteAttachFile', 'addAttachFiles', 'refreshCoc']),
    moment,
    nowStep,
    themeChange(e) {
      const val = e.target.value.trim()
      let Chinese = ''
      const pattern = /[\u4e00-\u9fa5]/g
      val.replace(pattern, function (match){
        Chinese += match
      })
      if (Chinese.length * 2 + (val.length - Chinese.length) > 30) {
        this.$message.warn(this.$t('home.More15ChineseOr30Char'))
        this.form.theme = this.preTheme
        return
      }
      this.form.theme = this.preTheme = val
    },
    getAttachName(name) {
      const textWidth = getTextWidth(name)
      if (textWidth <= chs10pt) { // 参考长度
        return [{
          text: name,
          width: 'auto'
        }] // 小于10长度，则直接返回
      }
      const lastDotIndex = name.lastIndexOf('.')
      let splitIndex = name.length - 3
      if (lastDotIndex > -1) {
        splitIndex = lastDotIndex - 2
      }
      const preText = name.substring(0, splitIndex)
      const suffixText = name.substring(splitIndex)

      const suffixWidth = getTextWidth(suffixText)
      return [{
        text: preText,
        width: parseInt(textWidth - suffixWidth - 9) + 'px' // 省略号占用8px
      }, {
        text: suffixText,
        width: 'auto'
      }]
    },
    async handleDeleteAttachFile(index) {
      this.originFiles.splice(index, 1)
    },
    getAttachDesc(file) {
      let nickName = null
      if (this.type === 'add') {
        nickName = this.userInfo.name
      } else {
        nickName = this.cocDetail.memberByUid[file.userId]?.nickName || '-'
      }
      const addTime = format(new Date(file.addTime * 1000), 'yyyy/MM/dd')
      return nickName + ' ' + addTime
    },
    // 比对表单数据是否有做修改
    compareForm(oForm, form) {
      if (oForm.theme !== form.theme){
        return true
      }
      // 开始和结束时间有默认值,清空相当于做了修改操作
      if (form.beginTime === null || form.endTime === null) {
        return true
      }
      if (oForm.beginTime.unix() !== form.beginTime.unix()) {
        return true
      }
      if (oForm.endTime.unix() !== form.endTime.unix()) {
        return true
      }
      if (oForm.tagList.length !== form.tagList.length || oForm.collaboratorList.length !== form.collaboratorList.length) {
        return true
      }
      if (oForm.tagList.length && form.tagList.length) {
        for (let i = 0; i < oForm.tagList.length; i++) {
          if (!form.tagList.some(el => el.id === oForm.tagList[i].id)) {
            return true
          }
        }
      }
      if (oForm.collaboratorList.length && form.collaboratorList.length) {
        for (let i = 0; i < oForm.collaboratorList.length; i++) {
          if (!form.collaboratorList.some(el => el.userId === oForm.collaboratorList[i].userId)){
            return true
          }
        }
      }
      return false
    },
    handleUploadAttachFile() {
      fileSelector(async (files) => {
        if (files.length === 1) {
          const file = files.item(0)
          if (file.size > 50 * 1024 * 1024) {
            this.$confirm({
              content: this.$t('home.More50MFile'),
              width: '460px',
              centered: true,
              class: 'confirm-exit',
              closable: true,
              cancelText: this.$t('common.Cancel'),
              okText: this.$t('common.Ok')
            })
          } else {
            const formData = new FormData()
            formData.append('file', file)

            const conferenceId = this.conferenceId
            const fileName = file.name

            if (conferenceId) {
              const cocDetail = this.cocDetail

              if (cocDetail && cocDetail.confererceState === CONFERENCE_STATE.IN_PROGRESS && cocDetail.roomId) {
                formData.append('channelId',)
              }
            }
            const url = await uploadFile(formData)
            this.originFiles = this.originFiles.concat({
              url,
              name: fileName,
              userId: this.userInfo.id,
              addTime: parseInt(Date.now() / 1000)
            })
          }
        }
      })
    },
    handleReset() {
      this.clearChecked()
      const initial = initialColAppointData(this)
      Object.keys(initial).forEach(key => { this[key] = initial[key] })
    },
    range(start, end) {
      const result = []
      for (let i = start; i < end; i++) {
        result.push(i)
      }
      return result
    },
    async onOk(){
      // 断网状态友好提示
      if (!navigator.onLine) {
        return this.$message.error(this.$t('home.NetworkErrorTryAgain'))
      }
      // 新建协作预约
      if (this.form.beginTime.valueOf() >= this.form.endTime.valueOf()) {
        return this.$message.error(this.$t('home.TimeUnavailable'))
      }

      if (this.form.beginTime.valueOf() < (+new Date())) {
        return this.$message.error(this.$t('home.TimeUnavailableOfLessthan'))
      }

      const isSpecialist = await this.$store.dispatch('getLabelAuthAppltSetting')
      if (this.type === 'add') {
        const createData = {
          theme: this.form.theme,
          beginTime: this.form.beginTime.unix(),
          endTime: this.form.endTime.unix(),
          members: this.form.collaboratorList.map(el => ({
            corpId: el.corpId,
            userId: el.userId,
            nickName: el.nickName
          })),
          tags: this.form.tagList.map(el => ({ id: el.id })),
          files: this.originFiles.map(({ url, name }) => ({ url, name })),
          mute: this.form.mute,
          isSpecialist: !isSpecialist
        }
        const result = await axios.post(
          '/hiapigw/app/conference/create',
          createData,
          {
            params: {
              _id: Global.genNonce(5)
            }
          }
        )
        if (result.data.code === 0) {
          this.$emit('change', false)
          this.$emit('appointSuccess', result.data.data.conferenceId)
        } else {
          this.$message.error(result.data.msg)
        }
      }
      // 修改协作预约
      if (this.type === 'modify') {
        const { addMembers, removeUserIDs } = this.getAddAndRemoveArray(this.originForm.collaboratorList, this.form.collaboratorList)
        const conferenceId = this.conferenceId
        const modifyData = {
          info: {
            conferenceId,
            theme: this.form.theme,
            beginTime: this.form.beginTime.unix(),
            endTime: this.form.endTime.unix(),
            tags: this.form.tagList.map(el => ({ id: el.id })),
            mute: this.form.mute,
            isSpecialist: !isSpecialist
          },
          addMembers: addMembers.map(el => {
            return {
              corpId: el.corpId,
              userId: el.userId,
              nickName: el.nickName,
            }
          }),
          removeUserIDs,
        }

        const removeFiles = differenceWith((a, b) => a.fid === b.fid, this.cloneOriginFiles, this.originFiles.filter(file => file.fid !== undefined))
        const addFiles = this.originFiles.filter(file => file.fid === undefined)
        const result = await axios.post(
          '/hiapigw/app/conference/modify',
          modifyData,
          {
            params: {
              _id: Global.genNonce(5)
            }
          }
        )
        if (result.data.code === 0) {
          this.$emit('change', false)

          const fileOpsReqs = []

          if (addFiles.length > 0) {
            fileOpsReqs.push(this.addAttachFiles({
              conferenceId,
              files: addFiles.map(({ url, name }) => ({ url, name, type: 0 })),
              notify: true
            }))
          }

          if (removeFiles.length > 0) {
            fileOpsReqs.push(this.deleteAttachFile({
              conferenceId,
              files: removeFiles.map(({ fid }) => ({ fid }))
            }))
          }

          if (fileOpsReqs.length > 0) {
            await Promise.allSettled(fileOpsReqs)
          }

          await this.refreshCoc(conferenceId)
        } else {
          this.$message.error(result.data.msg)
        }
      }
    },
    confirmExit() {
      const _this = this
      this.$confirm({
        content: this.$t('home.ModifiedContentContinueExit'),
        width: '460px',
        centered: true,
        class: 'confirm-exit',
        closable: true,
        okText: this.$t('common.Ok'),
        cancelText: this.$t('common.Cancel'),
        onOk(){
          _this.$emit('change', false)
        },
        onCancel(){}
      })
    },
    onCancel(){
      if (this.compareForm(this.originForm, this.form)) {
        return this.confirmExit()
      }
      this.$emit('change', false)
    },
    tagConfirm(tagChecked) {
      // 类型没有改变时，解决选择标签乱序问题
      if (tagChecked.length !== this.form.tagList.length) {
        this.form.tagList = tagChecked
      } else {
        for (let i = 0; i < this.form.tagList.length; i++) {
          if (!tagChecked.some(el => el.id === this.form.tagList[i].id)){
            this.form.tagList = tagChecked
            break
          }
        }
      }
    },
    inviteConfirm(members) {
      members = members.map(el => ({
        corpId: el.corpId,
        corpName: el.corpName,
        userId: el.uid,
        nickName: el.name,
      }))
      const { addMembers, removeUserIDs } = this.getAddAndRemoveArray(this.form.collaboratorList, members)
      addMembers.forEach(el => {
        const index = this.originForm.collaboratorList.findIndex(ele => ele.userId === el.userId)
        this.form.collaboratorList.push(
          index > -1
            ? this.originForm.collaboratorList[index]
            : el
        )
      })
      removeUserIDs.forEach(el => {
        const index = this.form.collaboratorList.findIndex(ele => ele.userId === el)
        this.form.collaboratorList.splice(index, 1)
      })
    },
    // 新增和修改共用此组件
    async handleCreate() {
      const userInfo = {
        corpId: this.userInfo.corpId,
        corpName: this.userInfo.corpName,
        userId: this.userInfo.id,
        nickName: this.userInfo.name
      }
      this.type = 'add'
      this.hostId = this.userInfo.id
      this.form.theme = this.preTheme = this.$t('home.CollaborationCreatedOf').replace('XX', this.userInfo.name)
      this.form.collaboratorList.push(userInfo)
      this.originForm.theme = this.$t('home.CollaborationCreatedOf').replace('XX', this.userInfo.name)
      this.originForm.collaboratorList.push(userInfo)
    },
    getAddAndRemoveArray(originData, newData) {
      const addMembers = []
      const removeUserIDs = []
      originData.forEach(el => {
        if (!newData.some(ele => ele.userId === el.userId)) {
          removeUserIDs.push(el.userId)
        }
      })
      newData.forEach(el => {
        if (!originData.some(ele => ele.userId === el.userId)) {
          addMembers.push({
            corpId: el.corpId,
            corpName: el.corpName,
            userId: el.userId,
            nickName: el.nickName,
          })
        }
      })
      return {
        addMembers,
        removeUserIDs,
      }
    },
    async handleModify(conferenceId) {
      this.type = 'modify'
      this.title = this.$t('home.Edit')
      this.cancelText = this.$t('common.Cancel')
      this.okText = this.$t('home.ConfirmChanges')
      this.conferenceId = conferenceId
      const data = await this.fetchCocDetail({ id: conferenceId, force: true })
      const { theme, beginTime, endTime, members, tags, hostId, files = [], mute } = data
      this.originFiles = files.slice(0)
      this.cloneOriginFiles = files.slice(0)
      this.form.theme = this.preTheme = theme
      this.form.beginTime = moment.unix(beginTime)
      this.form.endTime = moment.unix(endTime)
      this.form.collaboratorList = members
      this.form.tagList = tags
      this.form.mute = mute
      this.hostId = hostId
      tags.forEach(el => {
        this.checkTag(el.id)
      })
      this.originForm = {
        theme,
        beginTime: moment.unix(beginTime),
        endTime: moment.unix(endTime),
        collaboratorList: clone(members),
        tagList: clone(tags),
      }
    },
    disabledDate(val) {
      return val < moment().subtract(1, 'days').endOf('days')
    },
    disabledTime(val) {
      // 如果是当天，时分秒不能小于当前时间
      if (val.isSame(new Date(), 'day')) {
        return {
          disabledHours: () => {
            return this.range(0, 24).splice(0, moment().hour())
          },
          disabledMinutes: () => {
            return val.isSame(new Date(), 'hour')
              ? this.range(0, 60).splice(0, moment().add(1, 'minutes').minute())
              : []
          },
          disabledSeconds: () => ([])
        }
      }
    },
    _setInputDisabled () {
      this.$nextTick(() => {
        setTimeout(() => {
          [...document.querySelectorAll('.date-picker-simple .ant-calendar-input ')].forEach(item => {
            item.blur()
            item.setAttribute('disabled', 'disabled')
          })
        })
      })
    },
    handleStartOpenChange(open) {
      this._setInputDisabled()
      if (!open) {
        this.endOpen = true
      }
    },
    handleEndOpenChange(open) {
      this._setInputDisabled()
      this.endOpen = open
    }
  },
  created() {
    this.queryTagList()
  }
}
</script>

<style scoped lang="less">
@import url(~@/styles/font.less);
@modalBodyPadding: 24px;
@wrapper: 520px;
@wrapperLeft: 200px;
@gap: 24px;
@label: @wrapperLeft - @modalBodyPadding - @gap;

.labelFont {
  font-size: 16px;
  font-weight: 500;
  color: #000;
  &.required {
    &::before {
      display: inline-block;
      margin-right: 4px;
      color: #FD6565;
      font-size: 16px;
      line-height: 1;
      content: '*';
    }
  }
}
.Font(@fontSize, @fontWeight, @color) {
  font-size: @fontSize;
  font-weight: @fontWeight;
  color: @color;
}
.arrowRight {
  width: 16px;
  height: 16px;
  position: absolute;
  right: 16px;
  cursor: pointer;
}
::v-deep .collaboration-modal {
  .ant-modal {
    .ant-modal-content {
      border-radius: 16px;
      border: 1px solid #edeff2;
      box-shadow: 0 10px 20px 0 rgba(62, 85, 132, 0.3);
      .ant-modal-header {
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
        .ant-modal-title {
          .Font(18px,500,#000)
        }
      }
      .ant-modal-body {
        height: 610px;
        padding: 40px 0 0;
        overflow: hidden;
      }
    }
  }
  .close {
    position: absolute;
    top: 17px;
    right: 17px;
    height: 24px;
    width: 24px;
    line-height: 24px;
    color: #000;
    font-size: 20px;
    padding: 2px;
    border-radius: 4px;
    cursor: pointer;
    &:hover {
      color: #000;
      background-color: #eff3f8;
    }
  }
  .collaboration-container {
    height: 540px;
    padding: 0 20px 20px;
    padding-bottom: 100px;
    overflow: auto;
    .attach-container {
      min-height: 42px;
    }
    .attach-items {
      .attach-item-container {
        display: inline-block;
        padding: 10px 8px;
        border-radius: 8px;
        width: 244px;
        &:hover {
          background: #FBFCFD;
        }
      }
      .file-entity-icon {
        width: 30px;
        height: 32px;

      }
      .attach-info {
        display: inline-block;
        margin-left: 12px;
        &-name {
          .regular-font(16);
          color: #000000;
          display:flex;
          justify-content: flex-start;
          width: 158px;

          & > .attach-info-name-segment {
            &:first-child {
              flex-grow: 0;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
            &:last-child {
              flex-grow: 0;
              flex-shrink: 0;
              width: auto;
            }
          }
        }

        &-desc {
          .regular-font(12);
          color: #999B9F;
        }
      }

      .attach-action {
        display: block;
        line-height: 42px;
        float: right;
        & > .remove-btn {
          display: inline-block;
          width: 16px;
          height: 16px;
          background: url(~@/assets/remove.svg) left top / cover no-repeat;
          &:hover {
            cursor: pointer;
            background-image: url(~@/assets/remove-hover.svg);
          }
        }
      }
    }
    .upload-btn {
      .medium-font(14);
      display: table;
      margin: 0 auto 10px;
      height: 20px;
      line-height: 20px;
      & > .upload-text {
        display: inline-block;
        vertical-align: middle;
      }
      & > .icon-upload {
        width: 20px;
        height: 20px;
        margin-right: 4px;
        vertical-align: middle;
      }
    }
    .item {
      min-height: 42px;
      display: flex;
      flex-direction: row;
      // align-items: center;
      margin-top: 24px;
      &:first-child {
        margin-top: 16px;
      }
      .label {
        height: 42px;
        line-height: 42px;
        flex: 0 0 @label;
        text-align: right;
        margin-right: @gap;
        .labelFont()
      }
      .wrapper {
        min-height: 42px;
        flex: 0 0 @wrapper;
        &-pointer {
          cursor: pointer;
        }
        input {
          height: 42px;
          background: #EFF3F8;
          box-shadow: 0 0 10px 0 rgba(151, 171, 199, 0.15);
          border-radius: 8px;
          border: none;
          padding-left: 16px;
          padding-right: 16px;
          .Font(16px,400,#6A6D73)
        }
        .types {
          background: #EFF3F8;
          box-shadow: 0 0 10px 0 rgba(151, 171, 199, 0.15);
          border-radius: 8px;
          padding: 0 40px 0 16px;
          position: relative;
          .Font(16px,400,#6A6D73);
          .noTypes {
            min-height: 42px;
            line-height: 42px;
          }
          .hasTypes {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;
            padding-bottom: 11px;
            div {
              display: inline-block;
              height: 20px;
              line-height: 20PX;
              border-radius: 4px;
              padding: 0 8px;
              margin: 11px 8px 0 0;
              background-color: #fff;
              .Font(12px,400,#1F5EDB)
            }
          }
          .arrow-right {
            .arrowRight();
            top: 50%;
            margin-top: -8px;
          }
        }
        .collaborator {
          padding: 10px 16px;
          background: #EFF3F8;
          box-shadow: 0 0 10px 0 rgba(151, 171, 199, 0.15);
          border-radius: 8px;
          position: relative;
          .collaborator-item-container:first-child {
            padding-top: 0;
          }
          .arrow-right {
            .arrowRight();
            top: 10px;
          }
          .switch{
            display: flex;
            align-items: center;
            .text{
              margin-left: 10px;
            }
          }
        }
        .morePeople{
          padding: 10px 16px;
          font-weight: 500;
        }
      }
      .date-picker-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .start,.end {
          flex: 0 0 198px;
          .ant-calendar-picker-icon {
            right: 16px;
          }
          .ant-calendar-picker-clear {
            right: 16px;
          }
        }
        .end-label {
          .labelFont();
        }
      }
    }
  }
  .buttons {
    width: 798px;
    height: 113px;
    background: rgba(255, 255, 255, 0.85);
    box-shadow: 0px -10px 30px 0px rgba(89, 132, 219, 0.1);
    border-radius: 0 0 16px 16px;
    position: absolute;
    left: 0;
    bottom: 0;
    .basic-btns {
      height: 50px;
      margin-top: 22px;
      justify-content: flex-end;
      .ant-btn {
        height: 100%;
        // width: 144px;
        border-radius: 25px;
      }
      .default-btn {
        margin-right: 40px;
      }
      .primary-btn {
        margin-right: 92px;
      }
    }
  }
  .buttons.no-scroll {
    box-shadow: none;
  }
}

</style>
